import type { ReactElement } from "react"
import TextAtm from "@onestore/hel/dist/components/atoms/TextAtm"
import FlexContainerOrg from "@onestore/hel/dist/components/organisms/FlexContainerOrg"
import PushOrg from "@onestore/hel/dist/components/organisms/PushOrg"
import type { PeriodInfo } from "@core/period-info"
import type { PriceType } from "@core/types"
import LowestPriceInfo from "~/components/LowestPriceInfo"
import Tooltip from "~/components/Tooltip"

interface Props {
  prefix?: string
  periodInfo: PeriodInfo
  priceType: PriceType
  periodText?: string
  tooltip?: string
  priceHasPrimaryColor?: boolean
}

export default function Price({
  prefix,
  periodInfo,
  priceType,
  periodText,
  tooltip,
  priceHasPrimaryColor,
}: Props): ReactElement<Props> {
  const hasPromotion = periodInfo.hasPromotion()
  const { priceValue, lowestPrice } = periodInfo.getPrices(priceType)

  return (
    <>
      <PushOrg bottomSpace={0.5}>
        <FlexContainerOrg alignItems="center">
          <TextAtm
            typography="big3"
            data-test-id="advanced-product-card-regular-price"
          >
            {!hasPromotion && prefix ? (
              <TextAtm typography="tiny2" emphasis="medium">
                {prefix}{" "}
              </TextAtm>
            ) : null}
            <TextAtm
              color={
                hasPromotion || priceHasPrimaryColor ? "primary" : undefined
              }
            >
              {priceValue}
            </TextAtm>{" "}
            <TextAtm typography="tiny2" emphasis="medium">
              {periodText}
            </TextAtm>
          </TextAtm>

          {tooltip && hasPromotion ? (
            <PushOrg leftSpace={0.5}>
              <Tooltip
                zIndex={2}
                iconSize="large"
                data-testid="advanced-product-card-tooltip"
              >
                {tooltip}
              </Tooltip>
            </PushOrg>
          ) : null}
        </FlexContainerOrg>
      </PushOrg>

      {hasPromotion ? (
        <PushOrg topSpace={0.5}>
          <LowestPriceInfo value={lowestPrice} data-testid="lowest-price" />
        </PushOrg>
      ) : null}
    </>
  )
}
